import { render, staticRenderFns } from "./ProInfoUpdateTime.vue?vue&type=template&id=481ead95&scoped=true&"
import script from "./ProInfoUpdateTime.vue?vue&type=script&lang=js&"
export * from "./ProInfoUpdateTime.vue?vue&type=script&lang=js&"
import style0 from "./ProInfoUpdateTime.vue?vue&type=style&index=0&id=481ead95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ead95",
  null
  
)

export default component.exports